export default __webpack_public_path__ + "static/media/flatRate.050fa7b0.svg";